import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'

export default class extends Controller {
  connect() {
    this.categorySelect = null
  }

  openModal(event) {
    const feedbackId = event.currentTarget.dataset.feedbackId
    const productName = event.currentTarget.dataset.productName || ''
    const barcode = event.currentTarget.dataset.barcode || ''
    const imageUrl = event.currentTarget.dataset.imageUrl || ''
    const imageWidth = event.currentTarget.dataset.imageWidth || ''
    const imageHeight = event.currentTarget.dataset.imageHeight || ''

    // Update form actions with correct feedback ID
    const searchForm = document.getElementById('resolve-search-form')
    const createForm = document.getElementById('create-product-form')

    if (searchForm) {
      searchForm.action = `/admin/feedbacks/missing_products/${feedbackId}/resolution`
    }

    if (createForm) {
      createForm.action = `/admin/feedbacks/missing_products/${feedbackId}/product`
    }

    // Initialize TomSelect on category select if not already done
    this.initializeCategorySelect()

    // Dispatch event to open Alpine modal
    window.dispatchEvent(new CustomEvent('open-resolve-modal', {
      detail: {
        feedbackId: feedbackId,
        productName: productName,
        barcode: barcode,
        imageUrl: imageUrl,
        imageWidth: imageWidth,
        imageHeight: imageHeight
      }
    }))
  }

  initializeCategorySelect() {
    const categoryElement = document.getElementById('category-select')
    if (categoryElement && !categoryElement.tomselect) {
      new TomSelect('#category-select', { maxOptions: null })
    }
  }
}
